export function getView(showProgressBar) {
  return showProgressBar === false ? false : true
}
